import { throttleRunLast } from '../common/adapter'
import { isDev, devOrigin } from '../config/dev'
import { router } from './index'

/**
 * 跳转到无查看权限页
 */
export const gotoNoViewingPermission = throttleRunLast(() => {
  routerPush({
    name: 'error',
    params: { title: '没有查看权限', subTitle: '请在角色授权中添加查看权限' }
  })
}, 100)

/**
 * 跳转到获取权限失败页
 */
export const gotoGetPermissionsError = throttleRunLast((params) => {
  routerPush({
    name: 'error',
    params: { title: params ? `获取权限失败(${params})` : '获取权限失败', subTitle: '请关闭当前页面，重新打开' }
  })
}, 100)

/**
 * 跳转到登录失效页
 */
export const gotoError106 = throttleRunLast(() => {
  routerPush({ name: 'error', params: { title: '登录已失效', subTitle: '请关闭当前页面，重新打开' } })
}, 100)

/**
 * 接口重发2次后提示103错误
 */
export const gotoError103 = throttleRunLast(() => {
  routerPush({ name: 'error', params: { title: '授权失败', subTitle: '请关闭当前页面，重新打开' } })
}, 100)

/**
 * 删除当前的history，history栈添加一个新的记录，并跳转到该记录
 * @param {RouteLocationRaw} to
 */
export function routerReplace(to) {
  router.replace(to)
}

/**
 * 通过在历史堆栈中推送一个 entry，以编程方式导航到一个新的 URL。
 * @param {RouteLocationRaw} to
 */
export function routerPush(to) {
  router.push(to)
}

/**
 * 允许你在历史中前进或后退。
 * @param {Number} delta
 */
export function routerGo(delta) {
  router.go(delta)
}

/** 存放打开tab页的windows对象 */
const devTabWindowss = {}

/**
 * 用新的tab页打开链接
 * @param {*} tabId 打开的标签页Id
 * @param {*} tabTitle 打开的标签页Title
 * @param {*} path 打开路径
 * @param {*} pathType 路径类型（三个值） tdAdmin：本项目页面 tdBackground：原后台页面  external：其他的外部链接
 */
export function routerTab(obj) {
  const { tabId, tabTitle, path, pathType = 'tdAdmin', params } = obj
  const href = location.href
  if (isDev()) {
    let url
    if (pathType === 'tdAdmin') {
      url = href.replace(location.hash, '#' + path)
    } else if (pathType === 'tdBackground') {
      url = devOrigin.replace('https', 'http') + path
    } else if (pathType === 'external') {
      url = path
    }
    if (params) {
      Object.keys(params).forEach((key) => {
        url += '/' + params[key]
      })
    }
    if (devTabWindowss[path]) {
      devTabWindowss[path].focus()
    } else {
      devTabWindowss[path] = window.open(url)
    }
  } else {
    if (pathType === 'tdAdmin') {
      let url = '/Subsite/#/' + path
      if (params) {
        Object.keys(params).forEach((key) => {
          url += '/' + params[key]
        })
      }
      window.parent.addTab(tabId, tabTitle, url, null, true, true)
    } else {
      let url = path
      if (params) {
        Object.keys(params).forEach((key) => {
          url += '/' + params[key]
        })
      }
      window.parent.addTab(tabId, tabTitle, url)
    }
  }
}

/** 关闭tab页 */
// SubsitegoodsFileList
export function closeTab(currentId, targetId) {
  const hash = location.hash
  if (isDev()) {
    if (devTabWindowss[hash]) {
      devTabWindowss[hash].close()
      devTabWindowss[hash] = undefined
    } else {
      window.close()
    }
  } else {
    console.log('siTabsClose参数 ', currentId, targetId)
    window.parent.siTabsClose('si-tabs_' + currentId, targetId)
  }
}

/**删除 / 和 # */
function clearSpecial(str) {
  return str.replace(/[/#]/g, '')
}
